export default __webpack_public_path__ + "static/media/iconSuccess.8636b0ad.png";